import script from "./SystemSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SystemSwitcher.vue?vue&type=style&index=0&id=4f94ded8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f94ded8"]])

export default __exports__